import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceSummaryRowPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceSummaryAntePostBox = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            padding: ${theme.star.padding.small};
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.raceSummary.borderColor};
        @media ${theme.star.mediaQuery.tablet} {
            border-left: 1px solid  ${theme.star.raceSummary.borderColor};
        }
    `;
};

export const RaceSummaryAntePostBox = withConfig(theme => styled('li', { label: 'RaceSummaryAntePostBox' })<RaceSummaryRowPropsType>`
    ${({ variant }): SerializedStyles=> setRaceSummaryAntePostBox(variant, theme)};
    background-color: ${theme.star.raceSummary.bgColor};
    color: ${theme.star.raceSummary.txtColor};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    min-height: 50px;
    position: relative;
`);

export const RunnerCellAntePost = withConfig(theme => styled('div', { label: 'RunnerCellAntePost' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.meetingsAntePost.typography.fontSizePrimary};
    font-weight: ${theme.star.meetingsAntePost.typography.fontWeightPrimary};
    justify-content: center;
    line-height: ${theme.star.meetingsAntePost.typography.lineHeightPrimary};
    padding: 8px 12px;
`);
